import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import { AppDataService, ConfigService, DeliveryOrderService, RiderService, SignalrService } from 'app/services';
import { CustomWindow } from 'app/@types';
import { Utils } from 'app/utils';
import moment from 'moment';
import { Observable, Subscription } from 'rxjs';
import { MenuHomeEnum } from 'app/home';
import { StylesStatus } from 'app/models/users/StylesStatus';
import { OrderUtils } from 'app/utils/order-utils';
import { AppComponent } from 'app/app.component';
import { UserTableSettingsService } from 'app/services/user-table-settings.service';
import {ColumnSelectorComponent} from 'app/column-selector/column-selector.component';
import { OpsTowerMenuEnum } from 'app/ops-tower';
import { RiderGroupEnum } from 'app/models/enums/rider-group.enum';
import {
    ActiveOrdersModel, BookingStatus,
    BookingTabMenuEnum, BookingTabMenuModel, BookingTypeModel,
    FieldTypeEnum, RiderVehicleType,
    RiderVehicleTypeEnum,
    ServiceTypeEnum,
    XpressDeliveryStatus,
    ExportFileTypeModel,
    MenuPermissionConfig,
	MenuPermissionActionEnum,
	ReasonModel
} from 'app/models';
import { TableLazyLoadEvent } from 'primeng/table';
import { FileUpload } from 'primeng/fileupload';

declare let window: CustomWindow;

@Component({
    selector: 'active-orders',
    templateUrl: './active-orders.component.html',
    styleUrls: ['./active-orders.component.scss',
        '../../../styles/paginator.scss'],
    providers: [MessageService]
})
export class ActiveOrdersComponent implements OnInit, OnDestroy {
    private inFlightGetDeliveryOrdersKey: string | null = null;
    serviceTypes!: ServiceTypeEnum[];
    @Input()
    set _serviceTypes(value: ServiceTypeEnum[]) {
        if (this.serviceTypes) {
            this.serviceTypes = value;
            this.handleLazyLoad({
                first: 0,
                rows: this.rowsPerPage
            });
        } else {
            this.serviceTypes = value;
        }
        this.getBookTabMenuList();
    }

    public xpressDeliveryStatusEnum = XpressDeliveryStatus;
    public fieldTypeEnum = FieldTypeEnum;
    public serviceType!: ServiceTypeEnum;

    public vehicleType!: RiderVehicleTypeEnum;
    @Input()
    set _vehicleType(value: RiderVehicleTypeEnum) {
        this.vehicleType = value;
        this.activeOrdersHeaderSearch.vehicleType = this.vehicleType;
        this.selectedRiderVehicleTypes = [];
        if (value && this.vehicleType !== RiderVehicleTypeEnum.None) {
            this.selectedRiderVehicleTypes.push(this.vehicleType);
        }
    }

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    @Input()
    set _vehicleTypes(value: RiderVehicleTypeEnum[]) {
        if (value) {
            this.selectedRiderVehicleTypes = value;
        }
    }

    @Output() changedVisibleExportSidebarEmit = new EventEmitter<boolean>();
    changedVisibleExportSidebar(increased: any) {
        this.changedVisibleExportSidebarEmit.emit(increased);
	}

	@ViewChild('fu') fileUploader!: FileUpload;

    public deliveryOrders: Array<any> = [];

    public menuTabItems: MenuItem[] = [];
    public activeTabItem!: MenuItem;
	public bookingTabMenuActive!: BookingTabMenuEnum;
	public bookingTypeOptions = !this.appData.isBoracayLocation
		? BookingTypeModel.BookingTypeList : BookingTypeModel.BookingTypeBoracayList;
    public paymentMethodOptions = ActiveOrdersModel.BookingPaymentMethodList;
    public bookingLabelOptions = ActiveOrdersModel.BookingLabelList;
    public bookingRiderCompanyList = ActiveOrdersModel.BookingRiderCompanyList;

    public selectedColumns: any[] = [];
    public exportHeaderColumns: string[] = [];
    public exportDataColumns: string[] = [];

    // Grid settings
    public rowsPerPage: number = Utils.getRowsPerPageCount();
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;

    public activeOrdersHeaderSearch: any = {
        bookingId: null,
        status: null,
        bookingStatusObj: null,
        riderGroupObj: null,
        bookingType: null,
        vehicleType: null,
        customerName: null,
		deliveryRecipientName: null,
		deliverySenderName: null,
        riderName: null,
        pickupLocation: null,
        dropOffLocation: null,
        riderGroup: null,
        netFare: null,
        amountMapped: null,
        paymentMethod: null,
        date: null,
        cancelReason: null,
        city: null,
        attempts: null,
        membership: null,
        createdAt: null,
        scheduledAt: null,
        cityName: null,
        riderCompanyObj: null,
        surgeFactor: null,
		surgeFactorMapped: null,
		reasonType: null,
        bookingLabel: null
    };

    public riderVehicleTypeList = this.appData.isDumagueteLocation ? RiderVehicleType.RiderVehicleTypeDumagueteList
        : this.appData.isBoracayLocation ? RiderVehicleType.RiderVehicleTypeBoracayList
        : RiderVehicleType.RiderVehicleTypeXpressList;
    public bookingStatusList = ActiveOrdersModel.BookingStatusList;
    public riderGroupsList = this.getRiderGroup();

    public menuHomeEnumActive!: MenuHomeEnum;

    public arrayFilterStatuses: any = [];
    public arrayFilterBookingTypes: any = [];

    public filter: {
        searchName: string;
        selectedRider: any;
        startDate: any;
        endDate: any;
    } = { searchName: '', selectedRider: null, startDate: null, endDate: null };

    public riders: any;

    public loading: boolean = true;

    private searchTimer: number = 0;

    public visibleActiveOrdersFilter: boolean = false;

    public minRangeValue: number = 0;
    public maxRangeValue: number = 0;

    public minMaxRangeValue: number[] = [];
    public selectedRiderVehicleTypes: RiderVehicleTypeEnum[] = [];
    public selectedDeliveryStatuses: XpressDeliveryStatus[] = [];

    public orderId: number = 0;
    public driverId: number = 0;
    public selectedOrder: any = {};

    public showDetailOrderSideBar: boolean = false;
    public showExportSidebar: boolean = false;
    public exportLoading: boolean = false;
	public exportData: any = {};

	public bookingTabMenuEnum = BookingTabMenuEnum;

	public isActiveImportModal: boolean = false;
	public importFileSelected: boolean = false;
	public importFile: File | null = null;
	public errorMessageImport!: string;
	public loadingImportData: boolean = false;
	public selectedImportFileName: string = '';

	reasonList = ReasonModel.ReasonList;

    $deliveryOrders: Observable<any>;
    $deliveryOrdersSubject: Subscription | undefined;

    public cols: any[] = [];
    public defaultCols: any[] = [
        {
            field: 'Id', header: 'Booking ID', width: '20%', fieldType: FieldTypeEnum.InputNumber,
            model: 'bookingId', placeholder: 'Type here', active: false
        },
        {
            field: 'CreatedAt', header: 'Date and Time', width: '20%', fieldType: FieldTypeEnum.Calendar,
            model: 'createdAt', placeholder: 'Type here', active: false
        },
        {
            field: 'StatusText', header: 'Status', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Dropdown,
            model: 'bookingStatusObj', options: this.bookingStatusList, take: 'obj', placeholder: 'Select', active: false
        },
        {
            field: 'BookingTypeText', header: 'Booking Type', disableSort: false, width: '20%', fieldType: FieldTypeEnum.Dropdown,
            model: 'bookingType', options: this.bookingTypeOptions, placeholder: 'Select', active: false
        },
        {
            field: 'VehicleTypeText', header: 'Vehicle Type', disableSort: false, width: '20%', fieldType: FieldTypeEnum.Dropdown,
            model: 'vehicleType', options: this.riderVehicleTypeList, placeholder: 'Select', active: false
        },
        {
			field: 'DeliverySenderName', header: 'Sender Name', width: '20%', fieldType: FieldTypeEnum.Inputs,
			model: 'deliverySenderName', placeholder: 'Type here', active: false
        },
        {
            field: 'DeliveryRecipientName', header: 'Recipient Name', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'deliveryRecipientName', placeholder: 'Type here', active: false
        },
        {
            field: 'RiderName', header: 'Driver Name', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'riderName', placeholder: 'Type here', active: false
        },
        {
            field: 'PickupLocation', header: 'Pickup Location', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'pickupLocation', placeholder: 'Type here', active: false
        },
        {
            field: 'CityName', header: 'City', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'cityName', placeholder: 'Type here', active: false
        },
        {
            field: 'OrderAttemptsCount', header: 'Attempts', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'attempts', placeholder: 'Type here', active: false
        },
        {
            field: 'SurgeFactor', header: 'Surge Factor Static', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'surgeFactor', placeholder: 'Type here', active: false
        },
        {
            field: 'SurgeFactorMapped', header: 'Surge Factor Dynamic', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'surgeFactorMapped', placeholder: 'Type here', active: false
        },
        {
            field: 'AmountMapped', header: 'Fare Amount with Dynamic Surge', width: '20%', fieldType: FieldTypeEnum.InputNumber,
            model: 'amountMapped', placeholder: 'Type here', active: false
        }
    ];

    public scheduledAtModel = 'scheduledAt';
    public scheduledAtColumn = {
        field: 'ScheduledAt', header: 'Scheduled Date and Time', width: '20%', fieldType: FieldTypeEnum.Calendar,
        model: this.scheduledAtModel, placeholder: 'Type here', active: false
    };
    public scheduledAtStatusModel = 'bookingStatusObj';
    public statusColumn = {
        field: 'StatusText', header: 'Status', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Dropdown,
        model: this.scheduledAtStatusModel, options: this.bookingStatusList, take: 'obj', placeholder: 'Select', active: false
    };
    public scheduledAtStatusColumn = {
        ...this.statusColumn,
        options: this.bookingStatusList.map(status => (
            {
                ...status,
                name: status.name === 'Requesting' ? 'Open' : status.name
            }
        )),
    };

    public nonSendCols: any[] = [
        {
            field: 'Id', header: 'Booking ID', width: '20%', fieldType: FieldTypeEnum.InputNumber,
            model: 'bookingId', placeholder: 'Type here', active: false
        },
        {
            field: 'CreatedAt', header: 'Date and Time', width: '20%', fieldType: FieldTypeEnum.Calendar,
            model: 'createdAt', placeholder: 'Type here', active: false
        },
		this.statusColumn,
		{
			field: 'Reason', header: 'Reason', disableSort: false, width: '20%', fieldType: FieldTypeEnum.Dropdown,
			model: 'reasonType', options: this.reasonList, placeholder: 'Select', active: false
		},
        {
            field: 'BookingLabel', header: 'Booking Label', disableSort: true, width: '20%', fieldType: FieldTypeEnum.Dropdown,
            model: 'bookingLabel', options: this.bookingLabelOptions, placeholder: 'Select', active: false
        },
        {
            field: 'BookingTypeText', header: 'Booking Type', disableSort: false, width: '20%', fieldType: FieldTypeEnum.Dropdown,
            model: 'bookingType', options: this.bookingTypeOptions, placeholder: 'Select', active: false
        },
        {
            field: 'VehicleTypeText', header: 'Vehicle Type', disableSort: false, width: '20%', fieldType: FieldTypeEnum.Dropdown,
            model: 'vehicleType', options: this.riderVehicleTypeList, placeholder: 'Select', active: false
        },
        {
            field: 'CompaniesText', header: 'Rider Company', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Dropdown,
            model: 'riderCompanyObj', options: this.bookingRiderCompanyList, take: 'obj', placeholder: 'Select', active: false
        },
        {
            field: 'RiderGroup', header: 'Rider Group', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Dropdown,
            model: 'riderGroupObj', options: this.riderGroupsList, take: 'obj', placeholder: 'Select', active: false
        },
        {
            field: 'CustomerName', header: 'Customer Name', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'customerName', placeholder: 'Type here', active: false
        },
        {
            field: 'RiderName', header: 'Driver Name', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'riderName', placeholder: 'Type here', active: false
        },
        {
            field: 'PickupLocation', header: 'Pick up Location', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'pickupLocation', placeholder: 'Type here', active: false
        },
        {
            field: 'DropOffLocation', header: 'Drop-off Location', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'dropOffLocation', placeholder: 'Type here', active: false
        },
        {
            field: 'NetFare', header: 'Fare Amount', width: '20%', fieldType: FieldTypeEnum.InputNumber,
            model: 'netFare', placeholder: 'Type here', active: false
        },
        {
            field: 'AmountMapped', header: 'Fare Amount with Dynamic Surge', width: '20%', fieldType: FieldTypeEnum.InputNumber,
            model: 'amountMapped', placeholder: 'Type here', active: false
        },
        {
            field: 'PaymentMethod', header: 'Payment Method', disableSort: false, width: '20%', fieldType: FieldTypeEnum.Dropdown,
            model: 'paymentMethod', options: this.paymentMethodOptions, placeholder: 'Select', active: false
        },
        {
            field: 'Date', header: 'Booking Timestamp', width: '20%', fieldType: FieldTypeEnum.Calendar,
            model: 'date', placeholder: 'Type here', active: false
        },
        {
            field: 'CityName', header: 'City', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'cityName', placeholder: 'Type here', active: false
        },
        {
            field: 'OrderAttemptsCount', header: 'Attempts', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'attempts', placeholder: 'Type here', active: false
        },
        {
            field: 'SurgeFactor', header: 'Surge Factor Static', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'surgeFactor', placeholder: 'Type here', active: false
        },
        {
            field: 'SurgeFactorMapped', header: 'Surge Factor Dynamic', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'surgeFactorMapped', placeholder: 'Type here', active: false
		}
    ];

    public nonSendColsLgu: any[] = [
        {
            field: 'Id', header: 'Booking ID', width: '20%', fieldType: FieldTypeEnum.InputNumber,
            model: 'bookingId', placeholder: 'Type here', active: false
        },
        {
            field: 'CreatedAt', header: 'Date and Time', width: '20%', fieldType: FieldTypeEnum.Calendar,
            model: 'createdAt', placeholder: 'Type here', active: false
        },
        this.statusColumn,
        {
            field: 'BookingLabel', header: 'Booking Label', disableSort: true, width: '20%', fieldType: FieldTypeEnum.Dropdown,
            model: 'bookingLabel', options: this.bookingLabelOptions, placeholder: 'Select', active: false
        },
        {
            field: 'BookingTypeText', header: 'Booking Type', disableSort: false, width: '20%', fieldType: FieldTypeEnum.Dropdown,
            model: 'bookingType', options: this.bookingTypeOptions, placeholder: 'Select', active: false
        },
        {
            field: 'VehicleTypeText', header: 'Vehicle Type', disableSort: false, width: '20%', fieldType: FieldTypeEnum.Dropdown,
            model: 'vehicleType', options: this.riderVehicleTypeList, placeholder: 'Select', active: false
        },
        {
            field: 'CompaniesText', header: 'Rider Company', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Dropdown,
            model: 'riderCompanyObj', options: this.bookingRiderCompanyList, take: 'obj', placeholder: 'Select', active: false
        },
        {
            field: 'RiderGroup', header: 'Rider Group', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Dropdown,
            model: 'riderGroupObj', options: this.riderGroupsList, take: 'obj', placeholder: 'Select', active: false
        },
        {
            field: 'CustomerName', header: 'Customer Name', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'customerName', placeholder: 'Type here', active: false
        },
        {
            field: 'RiderName', header: 'Driver Name', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'riderName', placeholder: 'Type here', active: false
        },
        {
            field: 'PickupLocation', header: 'Pick up Location', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'pickupLocation', placeholder: 'Type here', active: false
        },
        {
            field: 'DropOffLocation', header: 'Drop-off Location', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'dropOffLocation', placeholder: 'Type here', active: false
        },
        {
            field: 'PaymentMethod', header: 'Payment Method', disableSort: false, width: '20%', fieldType: FieldTypeEnum.Dropdown,
            model: 'paymentMethod', options: this.paymentMethodOptions, placeholder: 'Select', active: false
        },
        {
            field: 'Date', header: 'Booking Timestamp', width: '20%', fieldType: FieldTypeEnum.Calendar,
            model: 'date', placeholder: 'Type here', active: false
        },
        {
            field: 'CityName', header: 'City', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'cityName', placeholder: 'Type here', active: false
        },
        {
            field: 'OrderAttemptsCount', header: 'Attempts', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'attempts', placeholder: 'Type here', active: false
        }
    ];

    public vehicleCols: any[] = [
        {
            field: 'Id', header: 'Booking ID', width: '20%', fieldType: FieldTypeEnum.InputNumber,
            model: 'bookingId', placeholder: 'Type here', active: false
        },
        {
            field: 'BookingTypeText', header: 'Booking Type', disableSort: false, width: '20%', fieldType: FieldTypeEnum.Dropdown,
            model: 'bookingType', options: this.bookingTypeOptions, placeholder: 'Select', active: false
        },
        {
            field: 'BookingLabel', header: 'Booking Label', disableSort: true, width: '20%', fieldType: FieldTypeEnum.Dropdown,
            model: 'bookingLabel', options: this.bookingLabelOptions, placeholder: 'Select', active: false
        },
        {
            field: 'VehicleTypeText', header: 'Vehicle Type', disableSort: false, width: '20%', fieldType: FieldTypeEnum.Dropdown,
            model: 'vehicleType', options: this.riderVehicleTypeList, placeholder: 'Select', active: false
        },
        {
            field: 'CompaniesText', header: 'Rider Company', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Dropdown,
            model: 'riderCompanyObj', options: this.bookingRiderCompanyList, take: 'obj', placeholder: 'Select', active: false
        },
        {
            field: 'RiderGroup', header: 'Rider Group', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Dropdown,
            model: 'riderGroupObj', options: this.riderGroupsList, take: 'obj', placeholder: 'Select', active: false
        },
        {
            field: 'CustomerName', header: 'Customer Name', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'customerName', placeholder: 'Type here', active: false
        },
        {
            field: 'RiderName', header: 'Driver Name', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'riderName', placeholder: 'Type here', active: false
        },
        {
            field: 'PickupLocation', header: 'Pick up Location', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'pickupLocation', placeholder: 'Type here', active: false
        },
        {
            field: 'DropOffLocation', header: 'Drop-off Location', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'dropOffLocation', placeholder: 'Type here', active: false
        },
        {
            field: 'NetFare', header: 'Fare Amount', width: '20%', fieldType: FieldTypeEnum.InputNumber,
            model: 'netFare', placeholder: 'Type here', active: false
        },
        {
            field: 'AmountMapped', header: 'Fare Amount with Dynamic Surge', width: '20%', fieldType: FieldTypeEnum.InputNumber,
            model: 'amountMapped', placeholder: 'Type here', active: false
        },
        {
            field: 'PaymentMethod', header: 'Payment Method', disableSort: false, width: '20%', fieldType: FieldTypeEnum.Dropdown,
            model: 'paymentMethod', options: this.paymentMethodOptions, placeholder: 'Select', active: false
        },
        {
            field: 'Date', header: 'Booking Timestamp', width: '20%', fieldType: FieldTypeEnum.Calendar,
            model: 'date', placeholder: 'Type here', active: false
        },
        {
            field: 'CancelReason', header: 'Cancellation Reason', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'cancelReason', placeholder: 'Type here', active: false
        },
        {
            field: 'StatusText', header: 'Status', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Dropdown,
            model: 'bookingStatusObj', options: this.bookingStatusList, take: 'obj', placeholder: 'Select', active: false
        },
        {
            field: 'SurgeFactor', header: 'Surge Factor Static', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'surgeFactor', placeholder: 'Type here', active: false
        },
        {
            field: 'SurgeFactorMapped', header: 'Surge Factor Dynamic', width: '20%', fieldType: FieldTypeEnum.Inputs,
            model: 'surgeFactorMapped', placeholder: 'Type here', active: false
        },
    ];
    isLGUAdmin: boolean = false;
    canImportHailedOrders: boolean = false;

    constructor(
        private messageService: MessageService,
        private deliveryOrderService: DeliveryOrderService,
        public configService: ConfigService,
        public app: AppComponent,
        private riderService: RiderService,
        private signalRService: SignalrService,
        private userTableSettings: UserTableSettingsService,
        private appData: AppDataService
    ) {
        this.$deliveryOrders = this.signalRService.DeliveryOrdersObservable;
        this.isLGUAdmin = this.appData.hasPermission(MenuPermissionConfig.LGU_ADMIN, MenuPermissionActionEnum.Read);
        this.canImportHailedOrders = this.appData.hasPermission(
            MenuPermissionConfig.OPS_TOWER_BOOKINGS,
            MenuPermissionActionEnum.Create);
    }

    ngOnInit(): void {
        this.signalRService.startConnection().then(() => {
            console.log('signalR Service connected');
            this.signalRService.addUpdateDeliveryOrdersListener();
            this.$deliveryOrdersSubject = this.$deliveryOrders.subscribe((data: any) => {
                this.callGridTitles(0);
            });
        });
    }

    ngOnDestroy() {
    this.signalRService?.disconnect();
        this.$deliveryOrdersSubject?.unsubscribe();
    }

    getRiderGroup() {
        if (this.app.opsRoot.activeMenu === OpsTowerMenuEnum.BookingMoto) {
            return ActiveOrdersModel.RiderGroupsList.filter(x => x.value === RiderGroupEnum.Moto);
        } else if (this.app.opsRoot.activeMenu === OpsTowerMenuEnum.BookingCars) {
            return ActiveOrdersModel.RiderGroupsList.filter(x => x.value === RiderGroupEnum.Car);
        } else {
            return ActiveOrdersModel.RiderGroupsList;
        }
    }

    onSelectedColumnsChange(event: any[]) {
        if (event && event.length > 0) {
            this.selectedColumns = event;
        }
        else {
            this.selectedColumns = this.cols;
        }

        this.exportHeaderColumns = this.selectedColumns.map(x => x.header);
        this.exportDataColumns = this.selectedColumns.map(x => x.field);
    }

    getBookTabMenuList() {
        this.serviceTypes.forEach(serviceType => {
            switch (serviceType) {
                case ServiceTypeEnum.Ride:
                case ServiceTypeEnum.Single:
                case ServiceTypeEnum.Charter:
                    if (this.vehicleType === RiderVehicleTypeEnum.PetTaxi) {
                        this.menuTabItems = ActiveOrdersModel.BookingPetTaxiTabMenuList;
                    } else {
                        this.menuTabItems = BookingTabMenuModel.BookingRideTabMenuList;
                    }
					break;
				case ServiceTypeEnum.Taxi:
					this.menuTabItems = BookingTabMenuModel.BookingTaxiTabMenuList;
					break;
                case ServiceTypeEnum.Delivery:
                    this.menuTabItems = BookingTabMenuModel.BookingSendTabMenuList;
                    break;
                case ServiceTypeEnum.Grocery:
                    this.menuTabItems = ActiveOrdersModel.BookingDeliveryTabMenuList;
                    break;
                case ServiceTypeEnum.Transfer:
                    this.menuTabItems = ActiveOrdersModel.BookingTransfersTabMenuList;
                    break;
                default: break;
            }
        });
        this.activeTabItem = this.menuTabItems[0];
    }

    public handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        if (this.app.opsRoot.activeMenu === OpsTowerMenuEnum.BookingSend) {
            this.cols = this.defaultCols;
            this.selectedColumns = this.defaultCols;
        }
        else if (this.app.opsRoot.activeMenu === OpsTowerMenuEnum.BookingMoto
                || this.app.opsRoot.activeMenu === OpsTowerMenuEnum.BookingCars
                || this.app.opsRoot.activeMenu === OpsTowerMenuEnum.BookingAdmin) {
            this.cols = this.vehicleCols;
            this.selectedColumns = this.vehicleCols;
        }
        else {
            this.cols = this.isLGUAdmin ? this.nonSendColsLgu : this.nonSendCols;
            this.selectedColumns = this.isLGUAdmin ? this.nonSendColsLgu : this.nonSendCols;
        }

        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(OpsTowerMenuEnum[this.app.opsRoot.activeMenu]+'-'+BookingTabMenuEnum[this.bookingTabMenuActive]);
        }
        this.callGridTitles(skip);
    }

    showSidebar() {
        if (!this.canContinue()){
            return;
        }
        this.showExportSidebar = true;
    }

    export() {
        if (!this.exportData.fileType) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select file type' });
            return;
        }

        this.exportLoading = true;
        const dto = this.getDeliveryOrdersDto(0, this.selectedRiderVehicleTypes, this.minMaxRangeValue, this.selectedDeliveryStatuses);
        this.deliveryOrderService.exportBookings(dto, this.messageService)
            .then(data => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Success' });
                Utils.saveFileResponse(data, 'Booking reports ' + moment(new Date()).format('DD MMM YYYY hh:mm:ss A'), this.exportData.fileType);
                this.exportLoading = false;
            })
            .catch(err => {
                this.exportLoading = false;
                throw err;
            });
	}

	showImportModal() {
		this.isActiveImportModal = true;
	}

	onImportFileSelect(event: any) {
		const file = event.files[0];
		if (file) {
			this.importFile = file;
			this.selectedImportFileName = file.name;
			this.importFileSelected = true;
		} else {
			this.importFile = null;
			this.selectedImportFileName = '';
			this.importFileSelected = false;
		}
	}

	onImportFileClear() {
		this.importFileSelected = false;
		this.importFile = null;
		this.loadingImportData = false;
		this.errorMessageImport = '';
	}

	saveImportFile() {
		if (!this.importFile) { return; }

		this.loadingImportData = true;

		const formData = new FormData();
		formData.append('formFile', this.importFile, this.importFile.name);
		formData.append('timeZoneOffset', Utils.getPhilippinesTimezoneHour().toString());

		this.deliveryOrderService.uploadHailedTaxiOrderFromXls(formData, this.messageService)
			.then(data => {
				if (!data) {
					this.loadingImportData = false;
					return;
				}

				if (!data.Success) {
					this.errorMessageImport = data.ErrorMessage;
					this.loadingImportData = false;
					return;
				}

				this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Data import was successful.' });
				this.callGridTitles(0);
				this.fileUploader.clear();
			})
			.catch(err => {
				this.loadingImportData = false;
				throw err;
			});
	}

    public getDeliveryOrdersDto(skip: number, selectedRiderVehicleTypes: RiderVehicleTypeEnum[],
                                minMaxRangeValue: number[], selectedDeliveryStatuses: XpressDeliveryStatus[]) {
        const dto = {
            BookingType: (this.activeOrdersHeaderSearch.bookingType) ? this.activeOrdersHeaderSearch.bookingType : null,
            BookingTabMenu: (this.bookingTabMenuActive) ? this.bookingTabMenuActive : null,
            ServiceTypes: this.serviceTypes,
            SearchName: this.filter.searchName,
            VehicleTypes: selectedRiderVehicleTypes.length !== 0 ? selectedRiderVehicleTypes : null,
            DeliveryStatuses: selectedDeliveryStatuses.length !== 0 ? selectedDeliveryStatuses : null,
            MinAmount: minMaxRangeValue[0] ?? null,
            MaxAmount: minMaxRangeValue[1] ?? null,
            BookingId: this.activeOrdersHeaderSearch.bookingId ? this.activeOrdersHeaderSearch.bookingId : null,
            CreatedAt: this.activeOrdersHeaderSearch.createdAt ?
                moment(Utils.utcToLocalDate(this.activeOrdersHeaderSearch.createdAt)).format('YYYY-MM-DDTHH:mm:ss') : null,
            ScheduledAt: this.activeOrdersHeaderSearch.scheduledAt ?
                moment(Utils.utcToLocalDate(this.activeOrdersHeaderSearch.scheduledAt)).format('YYYY-MM-DDTHH:mm:ss') : null,
            Status: this.activeOrdersHeaderSearch.status,
            Statuses: this.activeOrdersHeaderSearch.bookingStatusObj ? this.activeOrdersHeaderSearch.bookingStatusObj.value : null,
            CancelRole: this.activeOrdersHeaderSearch.bookingStatusObj ? this.activeOrdersHeaderSearch.bookingStatusObj.roleId : null,
            BookingServiceVehicleType: this.activeOrdersHeaderSearch.bookingType ? this.activeOrdersHeaderSearch.bookingType : null,
            ServiceType: this.serviceType ? this.serviceType : null,
            VehicleType: this.activeOrdersHeaderSearch.vehicleType ? this.activeOrdersHeaderSearch.vehicleType : null,
			DeliveryRecipientName: this.activeOrdersHeaderSearch.deliveryRecipientName ? this.activeOrdersHeaderSearch.deliveryRecipientName : '',
			DeliverySenderName: this.activeOrdersHeaderSearch.deliverySenderName ? this.activeOrdersHeaderSearch.deliverySenderName : '',
            CustomerName: this.activeOrdersHeaderSearch.customerName ? this.activeOrdersHeaderSearch.customerName : '',
            RiderName: this.activeOrdersHeaderSearch.riderName ? this.activeOrdersHeaderSearch.riderName : '',
            PickupLocation: this.activeOrdersHeaderSearch.pickupLocation ? this.activeOrdersHeaderSearch.pickupLocation : '',
            DropOffLocation: this.activeOrdersHeaderSearch.dropOffLocation ? this.activeOrdersHeaderSearch.dropOffLocation : '',
            RiderGroup: this.activeOrdersHeaderSearch.riderGroupObj ? this.activeOrdersHeaderSearch.riderGroupObj.value : null,
            NetFare: this.activeOrdersHeaderSearch.netFare ? this.activeOrdersHeaderSearch.netFare : null,
            AmountMapped: this.activeOrdersHeaderSearch.amountMapped ? this.activeOrdersHeaderSearch.amountMapped : null,
            PaymentMethod: this.activeOrdersHeaderSearch.paymentMethod ? this.activeOrdersHeaderSearch.paymentMethod : null,
            CancelReason: this.activeOrdersHeaderSearch.cancelReason ? this.activeOrdersHeaderSearch.cancelReason : '',
            FileType: this.exportData.fileType,
            Attempts: this.activeOrdersHeaderSearch.attempts ? this.activeOrdersHeaderSearch.attempts : null,
            CityName: this.activeOrdersHeaderSearch.cityName ? this.activeOrdersHeaderSearch.cityName : '',
            SurgeFactor: this.activeOrdersHeaderSearch.surgeFactor ? this.activeOrdersHeaderSearch.surgeFactor : null,
            SurgeFactorMapped: this.activeOrdersHeaderSearch.surgeFactorMapped ? this.activeOrdersHeaderSearch.surgeFactorMapped : null,
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder,
            XpressRiderId: this.filter.selectedRider ? this.filter.selectedRider.Id : null,
            StartDate: this.filter.startDate ? moment(this.filter.startDate).format('YYYY-MM-DDTHH:mm:ss') : null,
            EndDate: this.filter.endDate ? moment(this.filter.endDate).format('YYYY-MM-DDTHH:mm:ss') : null,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            HeaderColumns: this.exportHeaderColumns,
            DataColumns: this.exportDataColumns,
            ClientLocationType: this.appData.getClientLocationType(),
			CampaignType: this.activeOrdersHeaderSearch.riderCompanyObj ? this.activeOrdersHeaderSearch.riderCompanyObj.value : null,
			ReasonType: this.activeOrdersHeaderSearch.reasonType ? this.activeOrdersHeaderSearch.reasonType : null,
            BookingLabel: this.activeOrdersHeaderSearch.bookingLabel ? this.activeOrdersHeaderSearch.bookingLabel : ''
        };

        return dto;
    }

    public getDeliveryOrders(skip: number, selectedRiderVehicleTypes: RiderVehicleTypeEnum[],
        minMaxRangeValue: number[], selectedDeliveryStatuses: XpressDeliveryStatus[]): void {
        this.selectedRiderVehicleTypes = selectedRiderVehicleTypes;
        this.selectedDeliveryStatuses = selectedDeliveryStatuses;
        this.minMaxRangeValue = minMaxRangeValue;

        const dto = this.getDeliveryOrdersDto(skip, selectedRiderVehicleTypes, minMaxRangeValue, selectedDeliveryStatuses);
        const requestKey = JSON.stringify(dto);

        if (this.inFlightGetDeliveryOrdersKey === requestKey) {
            return;
        }

        this.inFlightGetDeliveryOrdersKey = requestKey;
        this.loading = true;

        this.deliveryOrderService.getDeliveryOrders(dto, this.messageService)
            .then(data => {
                if (this.inFlightGetDeliveryOrdersKey === requestKey) {
                    this.inFlightGetDeliveryOrdersKey = null;
                }
                this.loading = false;

                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.first = skip;
                this.totalRecords = data.TotalRecords;

                if (this.app.opsRoot.activeMenu === OpsTowerMenuEnum.BookingMoto || this.app.opsRoot.activeMenu === OpsTowerMenuEnum.BookingCars) {
                    this.deliveryOrders = data.Items;
                } else {
                    this.deliveryOrders = data.Items.map((x: any) => {
                        x.CreatedAt = Utils.utcToFormatedLocalDateStr(x.CreatedAt);
                        x.ScheduledAt = Utils.utcToFormatedLocalDateStr(x.ScheduledAt);
                        x.CustomerName = this.formatName(x.FullNameUser);
						x.DeliveryRecipientName = this.formatName(x.DeliveryRecipientName);
						x.DeliverySenderName = this.formatName(x.DeliverySenderName);
                        x.RiderName = this.formatName(x.FullNameRider);
                        x.VehicleTypeText = `${x.VehicleTypeText}`;
						x.CityName = (x.CityName) ? x.CityName : 'N/A';

                        this.mergeStatusDuplicates(OrderUtils.getStatusDisplayText(x.StatusText), x.StatusId);
                        return x;
                    });
                }

                if (data.TotalRecords !== 0 && this.minRangeValue === 0 && this.maxRangeValue === 0) {
                    const maxValue = this.deliveryOrders.reduce((prev, cur) => (cur.Amount > prev.Amount ? cur : prev));
                    const minValue = this.deliveryOrders.reduce((prev, cur) => (cur.Amount < prev.Amount ? cur : prev));

                    this.minRangeValue = minValue.Amount;
                    this.maxRangeValue = maxValue.Amount;
                }
                this.loading = false;
            })
            .catch(err => {
                if (this.inFlightGetDeliveryOrdersKey === requestKey) {
                    this.inFlightGetDeliveryOrdersKey = null;
                }
                this.loading = false;
                throw err;
            });
        this.mergeStatusDuplicates('All', -1);
    }

    public mergeStatusDuplicates(name: string, value: any) {
        if (name === '') {
            return;
        }
        const exists = this.arrayFilterStatuses.some((obj: any) => obj.name === name);
        if (!exists) {
            this.arrayFilterStatuses.push({
                name,
                value
            });
        }
    }

    public mergeBookingTypeDuplicates(name: string, value: any) {
        if (name === '') {
            return;
        }
        const exists = this.arrayFilterBookingTypes.some((obj: any) => obj.name === name);
        if (!exists) {
            this.arrayFilterBookingTypes.push({
                name,
                value
            });
        }
    }

    callGridTitles(skip: number) {
        this.getDeliveryOrders(skip, this.selectedRiderVehicleTypes, this.minMaxRangeValue, this.selectedDeliveryStatuses);
    }

    public handleHeaderFilterChange() {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }
        this.searchTimer = window.setTimeout(() => {
            this.callGridTitles(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public handleFilterChange(model: string, event: any): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            if (model === 'TransactionId') {
                this.activeOrdersHeaderSearch.transactionId = event;
            }
            this.callGridTitles(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public onChangeHeaderFilterDropDown(model: string, event: any) {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }
        if (model === 'VehicleType') {
            this.activeOrdersHeaderSearch.vehicleType = event ? event.VehicleTypeId : null;
        }
        if (model === 'BookingType') {
            this.vehicleType = event.VehicleTypeId;
            this.serviceType = event.ServiceTypeId;
        }
        if (model === 'StatusText') {
            if (event === -1) {
                this.activeOrdersHeaderSearch.status = null;
            }
        }
        this.searchTimer = window.setTimeout(() => {
            this.callGridTitles(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public openActiveOrdersFilter() {
        this.visibleActiveOrdersFilter = !this.visibleActiveOrdersFilter;
    }

    // Formats a given name into title case with initials for middle names and last name.
    formatName(name: string) {
        if (!name) {
            return '';
        }
        const parts = name.split(' ');
        const formattedParts = parts.map(part => part.charAt(0).toUpperCase() + part.slice(1));

        let formattedName = formattedParts.shift();
        if (formattedParts.length > 1) {
            formattedName += ' ' + formattedParts.slice(0, -1).map(part => part.charAt(0) + '.').join(' ');
        }
        const lastName = formattedParts.pop();
        if (lastName) {
            formattedName += ' ' + lastName.charAt(0) + '.';
        }

        return formattedName;
    }

    public clickChangeMenuHomeActive(value: MenuHomeEnum) {
        this.menuHomeEnumActive = value;
    }

    public xpressDeliveryStatus = XpressDeliveryStatus;

    getStatusStyles(status: BookingStatus): StylesStatus {
        let backgroundColor: string;
        let textColor: string;

        switch (status) {
            case BookingStatus.Requesting:
                backgroundColor = '#FFC043';
                textColor = '#004060';
                break;
            case BookingStatus.PickingUp:
                backgroundColor = '#A1BDCA';
                textColor = '#004060';
                break;
            case BookingStatus.Completed:
                backgroundColor = '#1CBA70';
                textColor = '#FFFFFF';
                break;
            case BookingStatus.Arrived:
                backgroundColor = '#0A84FF';
                textColor = '#FFFFFF';
                break;
            case BookingStatus.WaitingForPassenger:
                backgroundColor = '#F77F00';
                textColor = '#FFFFFF';
                break;
            case BookingStatus.WaitingExtended:
                backgroundColor = '#A53D27';
                textColor = '#FFFFFF';
                break;
            case BookingStatus.Canceled:
                backgroundColor = '#EB4236';
                textColor = '#FDEBEA';
                break;
            case BookingStatus.Assigned:
                backgroundColor = '#A1BDCA';
                textColor = '#004060';
                break;
            case BookingStatus.OnTrip:
                backgroundColor = '#0A84FF';
                textColor = '#FFFFFF';
                break;
            default:
                backgroundColor = '';
                textColor = '';
        }

        return {
            backgroundColor,
            color: textColor
        };
    }

    public openActiveOrderDetail(order: any) {
        if(this.isLGUAdmin) {
            return;
        }

        this.orderId = order.Id;
        this.driverId = order.XpressRiderId;
        this.selectedOrder = order;
        this.showDetailOrderSideBar = !this.showDetailOrderSideBar;
    }

    changedShowDetailOrderSideBarEmit(value: any) {
        this.showDetailOrderSideBar = value;
    }

    toggleScheduledColumn(id: number): void {
        const START_INDEX = 0;
        const END_INDEX = 2;
        const CONTINUE_INDEX = 3;
        const hasScheduledAtColumn = this.nonSendCols.some(col => col.model === this.scheduledAtModel);

        if (id === BookingTabMenuEnum.Scheduled) {
            if (!hasScheduledAtColumn) {
                this.nonSendCols = [
                    ...this.nonSendCols.slice(START_INDEX, END_INDEX),
                    this.scheduledAtColumn,
                    this.scheduledAtStatusColumn,
                    ...this.nonSendCols.slice(CONTINUE_INDEX)
                ];
            }
            return;
        }

        this.nonSendCols = this.nonSendCols.filter(
            (col) => col.model !== this.scheduledAtModel
        );
        this.nonSendCols = this.nonSendCols.map(
            (col) => col.model === this.scheduledAtStatusModel ? this.statusColumn : col
        );
    }

    changeBookingTabMenuActive(item: MenuItem) {
        this.toggleScheduledColumn(Number(item.id));

        this.activeTabItem = item;
        this.cleaneHeaderSearchFilters();

        const tabId = (item.id) ? item.id : '0';
        this.bookingTabMenuActive = parseInt(tabId, 10);

        this.handleLazyLoad({
            first: 0,
            rows: this.rowsPerPage
        });
    }

    private cleaneHeaderSearchFilters() {
        this.activeOrdersHeaderSearch = {
            bookingId: null,
            status: null,
            bookingStatusObj: null,
            bookingType: null,
            vehicleType: RiderVehicleTypeEnum.None,
            customerName: null,
			deliveryRecipientName: null,
			deliverySenderName: null,
            riderName: null,
            pickupLocation: null,
            city: null,
            attempts: null,
            membership: null,
            createdAt: null,
            scheduledAt: null,
            cityName: null,
            surgeFactor: null,
            surgeFactorMapped: null,
			reasonType: null,
            bookingLabel: null
        };
    }

    canContinue() {
        return this.filter.startDate && this.filter.endDate;
    }

    protected readonly OrderUtils = OrderUtils;
    protected readonly OpsTowerMenuEnum = OpsTowerMenuEnum;
    protected readonly ExportFileTypeModel = ExportFileTypeModel;
    protected readonly BookingTabMenuEnum = BookingTabMenuEnum;
}
